/**
 * Fanger opp vervekode fra vennelenke (?ref=CODE) og holder den til brukeren har
 * opprettet konto (#3 Reciprocity). Gaven kommer først: vervet får premium umiddelbart
 * ved oppretting, så koden må overleve fram til signup. Se docs/plan-ux-principles-retention.md.
 *
 * Ren logikk (query-string inn), localStorage-tilgang er try/catch-et så den aldri kaster.
 */

const PENDING_KEY = 'fricamp_pending_ref';
const MAX_CODE_LEN = 12;

/** Trekk ut og lagre ?ref fra en query-streng. Returnerer koden (normalisert) eller null. */
export function captureReferralFromUrl(search: string): string | null {
  let raw: string | null = null;
  try {
    raw = new URLSearchParams(search).get('ref');
  } catch {
    return null;
  }
  if (!raw) return null;
  const code = raw.trim().toUpperCase().slice(0, MAX_CODE_LEN);
  if (!/^[0-9A-Z]+$/.test(code)) return null;
  try { localStorage.setItem(PENDING_KEY, code); } catch { /* ignore */ }
  return code;
}

export function getPendingReferral(): string | null {
  try { return localStorage.getItem(PENDING_KEY); } catch { return null; }
}

export function clearPendingReferral(): void {
  try { localStorage.removeItem(PENDING_KEY); } catch { /* ignore */ }
}
